import Crud from '../views/Totem/Crud'
import Entity from '../views/Totem/View'

let routes = {
    path: '/totens',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/totens/view/:id?',
            name: 'ViewTotem',
            component: Entity,
            meta: {
                pageTitle: 'Visualizar Totem',
                breadcrumb: [
                    {
                        text: 'Totens',
                        active: false,
                        to: '/totens',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/totens',
            name: 'list-totens',
            component: Crud,
            meta: {
                pageTitle: "Lista de Totens",
                breadcrumb: [
                    {
                        text: "Totens",
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
